import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class SelectComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentSelect | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.autofocus = settings?.autofocus ?? false;
		this.dataSrc = settings?.dataSrc ?? 'values';
		if (settings?.data) {
			if (this.dataSrc === 'values' && 'values' in settings.data) {
				this.data = {
					values: settings.data.values,
					json:   '',
					custom: '',
				};
			}
			else if (this.dataSrc === 'json' && 'json' in settings.data) {
				this.data = {
					values: [],
					json:   settings.data.json,
					custom: '',
				};
			}
			else if (this.dataSrc === 'nodes' && 'nodes' in settings.data) {
				this.data = {
					values: [],
					json:   '',
					custom: settings.data.nodes,
				};
			}
		}
		this.defaultValue = settings?.defaultValue ?? '';
		this.event = {
			onChange: undefined,
			...settings?.event,
		};
		this.filter = settings?.filter ?? '';
		this.input = true;
		this.kdata = {
			submit: true,
			...settings?.kdata,
		};
		this.options = {
			collapsed:   null,
			collapsible: null,
			...settings?.options,
		};
		this.persistent = settings?.persistent ?? true;
		this.placeholder = settings?.placeholder ?? '';
		this.protected = settings?.protected ?? false;
		this.refreshOn = settings?.refreshOn ?? '';
		this.template = settings?.template ?? '<span>{{ item.label }}</span>';
		this.validate = {
			card:          new Card(settings?.validate?.card ?? '0-1'),
			custom:        settings?.validate?.custom ?? '',
			customMessage: settings?.validate?.customMessage,
		};
		this.valueProperty = settings?.valueProperty ?? '';
	}
}
